import { render, staticRenderFns } from "./MyPrompt.vue?vue&type=template&id=f25d0c62&scoped=true&"
import script from "./MyPrompt.vue?vue&type=script&lang=js&"
export * from "./MyPrompt.vue?vue&type=script&lang=js&"
import style0 from "./MyPrompt.vue?vue&type=style&index=0&id=f25d0c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25d0c62",
  null
  
)

component.options.__file = "MyPrompt.vue"
export default component.exports